export default "__VITE_ASSET__48a866e9__"